/**
 * fetchWrapper
 * 
 * Description:
 * Use to call the API
 * 
 */

import { store, authActions } from "./../store/index";
import HttpStatus from "./../helpers/status.enum";

export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

function request(method) {
  return (url, body) => {
    const requestOptions = {
      method,
      headers: authHeader(url),
    };
    requestOptions.headers["X-Frame-Options"] = "SAMEORIGIN"; // For Security added DENY OR SAMEORIGIN
    requestOptions.headers["Api-key"] = process.env.REACT_APP_API_SECURITY_TOKEN; 
    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";      
      requestOptions.body = JSON.stringify(body);
    }
    return fetch(url, requestOptions).then(handleResponse);
  };
}

// Helper functions
function authHeader(url) {
  // Return auth header with jwt if user is logged in and request is to the api url
  const token = authToken();
  const isLoggedIn = !!token;
  const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
  if (isLoggedIn && isApiUrl) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}

function authToken() {
  return store.getState().auth.value?.token;
}

async function handleResponse(response) {
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const data = isJson ? await response.json() : null;

  // Check for error response
  if (!response.ok) {
    if ([HttpStatus.HTTP_UNAUTHORIZED, HttpStatus.HTTP_FORBIDDEN].includes(response.status) && authToken()) {
      // Auto logout if 401 Unauthorized or 403 Forbidden response returned from api
      const logout = () => store.dispatch(authActions.logout());
      logout();
    }

    /* 
    Get error message from body or default to response status
    const error = (data && data.message) || response.status;
    return Promise.reject(error);
    */

    // Return all error with status code
    const error = data || response.status;
    return error;
  }

  return data;
}
